import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  GetOverview,
  GetDemographicData,
  GetOverviewMapsData,
  GetOverviewProposalsByPlans,
  GetOverviewSalesForecast,
  GetProposalsSituation,
} from '../../../store/actions';

/**
 * DashboardInjection is responsible for injecting the methods about store.
 *
 * @return
 *  get: () => Void
 *
 */
export const DashboardInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   */
  const getOverviewProposalsByPlans = async (office) => {
    dispatch(GetOverviewProposalsByPlans(office));
  };

  const getOverview = async (office) => {
    dispatch(GetOverview(office));
  };

  const getDemographicData = async (office) => {
    dispatch(GetDemographicData(office));
  };

  const getOverviewMapsData = async (office) => {
    dispatch(GetOverviewMapsData(office));
  };

  const getOverviewSalesForecast = async (office) => {
    dispatch(GetOverviewSalesForecast(office));
  };

  const getProposalsBySituation = async (situation) => {
    dispatch(GetProposalsSituation(situation));
  };

  /**
   * @return Void  
  /**
   * 
   *
   *
   */

  const {
    metrics,
    error,
    success,
    loading,
    markers,
    demographic,
    successMarkers,
    proposalsByPlans,
    successDemographic,
    successProposalsByPlans,
    salesForecast,
    successForecast,
    proposalsBySituation,
    successSituation,
    loadingSalesEvolution,
    loadingByPlans,
    loadingDemo,
    loadingMap,
  } = useSelector((state) => ({
    metrics: state.Overview.metrics,
    error: state.Overview.error,
    success: state.Overview.success,
    demographic: state.Overview.demographic,
    proposalsByPlans: state.Overview.proposalsByPlans,
    successDemographic: state.Overview.successDemographic,
    successProposalsByPlans: state.Overview.successProposalsByPlans,
    markers: state.Overview.markers,
    successMarkers: state.Overview.successMarkers,
    salesForecast: state.Overview.salesForecast,
    successForecast: state.Overview.successForecast,
    loading: state.Overview.loading,
    proposalsBySituation: state.Overview.proposalsBySituation,
    successSituation: state.Overview.successSituation,
    loadingSalesEvolution: state.Overview.loadingSalesEvolution,
    loadingByPlans: state.Overview.loadingByPlans,
    loadingDemo: state.Overview.loadingDemo,
    loadingMap: state.Overview.loadingMap,
  }));

  return {
    error,
    success,
    loading,
    metrics,
    markers,
    getOverview,
    demographic,
    salesForecast,
    successMarkers,
    successForecast,
    proposalsByPlans,
    successDemographic,
    getDemographicData,
    getOverviewMapsData,
    successProposalsByPlans,
    getOverviewSalesForecast,
    getOverviewProposalsByPlans,
    getProposalsBySituation,
    proposalsBySituation,
    successSituation,
    loadingSalesEvolution,
    loadingByPlans,
    loadingDemo,
    loadingMap,
  };
};
